import { NgModule } from '@angular/core';
import { NgOptimizedImage } from '@angular/common';
import { Title } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { Icd10v3Component } from './views/who/icd10v3/icd10v3.component';


// Import routing module
import { AppRoutingModule } from './app-routing.module';

// Import app component
import { AppComponent } from './app.component';

// Import containers
import {
    DefaultHeaderComponent,
    DefaultLayoutComponent,
} from './containers';

import {
    BreadcrumbModule,
    DropdownModule,
    GridModule,
    HeaderModule,
    SidebarModule,
} from '@coreui/angular';

import { IconModule, IconSetService } from '@coreui/icons-angular';
import { HttpClient, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { MyLinkDirective } from '../shared/directive/my-link.directive';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { ToastrModule } from 'ngx-toastr';
import { LanguageComponent } from './views/who/language/language.component';
import { RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms'; // Import FormsModule
import { MaintenancePopupComponent } from '../components/maintenance-popup/maintenance-popup.component';
import { SenseSphereCallbackComponent } from './views/who/auth/sensesphere-callback.component';

export function createTranslateLoader(http: HttpClient) {
    return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

const APP_CONTAINERS = [
    DefaultHeaderComponent,
    DefaultLayoutComponent,
    MyLinkDirective,
];

@NgModule({ declarations: [
        AppComponent,
        ...APP_CONTAINERS,
        LanguageComponent,
        Icd10v3Component, // Thêm Icd10v3Component
        MaintenancePopupComponent,
        SenseSphereCallbackComponent,
    ],
    bootstrap: [AppComponent], imports: [BrowserAnimationsModule,
        BreadcrumbModule,
        DropdownModule,
        GridModule,
        HeaderModule,
        IconModule,
        RouterModule,
        SidebarModule,
        AppRoutingModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: createTranslateLoader,
                deps: [HttpClient],
            },
        }),
        ToastrModule.forRoot({
            timeOut: 2000,
            positionClass: 'toast-top-right',
            preventDuplicates: true,
        }),
        NgOptimizedImage,
        FormsModule],     providers: [
        IconSetService,
        Title,
        provideHttpClient(withInterceptorsFromDi()),
    ] })
export class AppModule {}
